<template>
	<div class="contatiner">
		<div class="p-add-content">
			<div class="description title">{{qr.title}}</div>
			<div class="description remark">{{qr.remark}}</div>
			<div class="p-img-wrapper">
				<van-image v-if="qr.url && !loading" class="qr" fit="contain" :src="qr.url" />
				<van-icon v-if="!qr.url && !isFirstLoad" name="photo-o" color="#aaaaaa" size="240" />
			</div>
			<div class="chen">
				长按识别
			</div>
			<div class="tip-wrapper">
				<!-- div class="tip">如无法通过，请手动联系微信 <van-button size="mini" plain type="info"
						@click="copy($event, 'dayanzai999')">dayanzai999</van-button>
				</div>
				<div class="copy-tip">点击微信号即可复制</div> -->
			</div>
		</div>
		<img class="img_sao" src="../../../asset/sao.png" alt="img">
	</div>
</template>

<script>
	import {
		Cell,
		CellGroup,
		Field,
		Image,
		Loading,
		Button,
		Notify,
		NoticeBar,
		Grid,
		GridItem,
		Toast,
		Icon
	} from 'vant';
	import https from '../../../https'
	import {
		setOpenid,
		getOpenid
	} from '../../../util/auth'
	import {
		createHash
	} from '../../../util/hash'
	import hb from '../../../../static/hb.jpg'
	import arrow from '../../../../static/arrow.gif';

	export default {
		components: {
			[Cell.name]: Cell,
			[Field.name]: Field,
			[CellGroup.name]: CellGroup,
			[Image.name]: Image,
			[Loading.name]: Loading,
			[Button.name]: Button,
			[Notify.name]: Notify,
			[NoticeBar.name]: NoticeBar,
			[Grid.name]: Grid,
			[GridItem.name]: GridItem,
			[Icon.name]: Icon
		},
		data() {
			return {
				isFirstLoad: true,
				c: undefined,
				code: '',
				name: '',
				qr: {
					title: "",
					url: "",
				},
				hb,
				arrow,
				loading: false,
				introduce: {}
			};
		},
		created() {
			let code = this.$route.query.code
			this.getCode(code)
		},
		methods: {
			onClickCart(e, value, name) {
				this.isFirstLoad = false;
				this.code = value;
				this.name = name;
				this.getCode(value)
			},
			getCode(code) {
				var openid = getOpenid()
				if (!openid) {
					openid = createHash(16);
					setOpenid(openid);
				}
				var that = this
				that.loading = true
				https.fetchGet('/api/wx/lc/getLiveCode/' + getOpenid(), {
					code: code
				}).then(res => {
					if (res.data && res.data.data) {
						var data = res.data.data;
						that.qr = data
						that.loading = false
					}
				}).catch(err => {
					that.loading = false
					Notify({
						type: 'warning',
						message: '当前人数过多，请稍后重试'
					});
					console.log(err)
				})

			},
			getActivity() {
				https.fetchGet('/api/wx/lc/findActivity/15').then(res => {
					if (res.data && res.data.data) {
						this.introduce = res.data.data
					}
				}).catch(err => {
					this.loading = false
					Notify({
						type: 'warning',
						message: '当前人数过多，请稍后重试'
					});
					console.log(err)
				})
			},
			copy(e, value) {
				try {
					const input = document.createElement('textarea')
					input.value = value
					document.body.appendChild(input)
					input.select()
					document.execCommand('Copy')
					document.body.removeChild(input)
					Toast.success('复制成功');
				} catch (e) {
					Toast.fail('复制失败');
				}

			}
		}
	};
</script>

<style>
	.contatiner {
		width: 100%;
		min-height: 100vh;
		background: #453FFF;
		overflow: hidden;
	}
	.title{
		width: 492px;
		height: 84px;
		background: #FFE65F;
		border-radius: 42px;
		border: 3px solid #420002;
		margin: 49px auto 0;
		line-height: 84px;
		color: #420002;
		font-weight: bold;
		text-align: center;
		font-size: 38px;
	}
	.remark{
		color: #420002;
		text-align: center;
		margin-top: 29px;
		font-size: 32px;
	}
	.img_sao{
		width: 246px;
		height: 328px;
		position: fixed;
		right: 0;
		top:720px;
	}
	.chen{
		width: 232px;
		height: 60px;
		background: #FFE65F;
		box-shadow: 0px 10px 20px 0px rgba(255, 230, 95, 0.18);
		border-radius: 44px;
		line-height: 60px;
		margin: 30px auto 0;
		text-align: center;
		font-weight: bold;
		color: #000;
		font-size: 30px;
	}
	.p-img-wrapper {
		width: 340px;
		height: 340px;
		margin: 40px auto 0;
		background-image: url(../../../asset/juan.png);
		background-size: 100% 100%;
		padding: 30px 40px;
	}

	.code-wrapper {
		width: 100%;
		padding: 0 5px;
		overflow-x: scroll;
		display: -webkit-box;
		display: flex;
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap;
		box-sizing: border-box;
	}

	.code-wrapper::-webkit-scrollbar {
		display: none;
	}

	.code {
		display: flex;
		margin: 5px;
		margin-right: 0;
		justify-content: center;
		align-items: center;
		color: #666;
		border-radius: 6px;
		font-size: 14px;
		border: 1px solid #eee;
		height: 40px;
		padding: 0 6px;
	}

	.code-selected {
		background: rgb(107, 216, 252);
		border: 1px solid rgb(107, 216, 252);
		color: #fff;
	}

	.name {
		font-size: 20px;
		font-weight: bold;
		color: #333;
	}


	.p-add-content {
		width: 652px;
		border-radius: 30px;
		margin: 0 auto;
		overflow: hidden;
		background-color: #fff;
		font-size: 15px;
		color: #333;
		margin-top: 80px;
		padding-bottom: 90px;
	}

	.qr {
		width: 100%;
	}

	.cg {
		margin-top: 3%;
		margin-bottom: 3%;
	}

	.tip-wrapper {
		margin-top: 20px;
		width: 100%;
		text-align: center;
	}

	.tip {
		font-size: 13px;
	}

	.copy-tip {
		margin-top: 12px;
		font-size: 11px;
		color: #aaa;
	}

	.van-button--mini {
		min-width: 66px;
	}

	.color {
		font-size: 18px;
		color: #3d9dfd;
	}

	.h1 {
		margin: 24px 0;
		font-size: 18px;
		color: #df402a;
	}

	.text {
		margin: 10px 0;
		line-height: 32px;
	}

	.wx-tip {
		color: #666;
		font-size: 13px;
	}

	.p-add-arrow {
		width: 30px;
		margin-top: 12px;
	}
</style>
